export default __webpack_public_path__ + "static/dashboard-linking-4d64b5ca80de090de769d358b163a4d8.gif";